import React, { useState } from 'react'
import PropTypes from 'prop-types'
import OrganizersTable from './organizers-table'
import TermsTable from './terms-table'
import OrganizerForm from './organizer-form'
import TermForm from './term-form'
import FlashAlert from '../flash-alert'
import CheckInput from './inputs/check-input'
import { ajaxDelete, ajaxPatch } from '../../ajax'

function Partner(props) {
  const { data, organizers, terms } = props
  const [alert, setAlert] = useState()
  const [loading, setLoading] = useState(false)
  const [organizerForm, setOrganizerForm] = useState()
  const [termForm, setTermForm] = useState()

  const onOrganizerCreated = (data) => {
    props.onCreateOrganizer(data)
    setOrganizerForm()
    setAlert({ text: 'Organizer has been added', type: 'success' })
  }

  const onOrganizerUpdated = (data) => {
    props.onUpdateOrganizer(data)
    setOrganizerForm()
    setAlert({ text: 'Organizer has been updated', type: 'success' })
  }

  const onDeleteOrganizerClicked = async (organizer) => {
    if (window.confirm('Are you sure you want to delete the organizer?')) {
      deleteOrganizer(organizer)
    }
  }

  const deleteOrganizer = async (organizer) => {
    setLoading(true)
    const url = `/admins/partners/${data.id}/organizers/${organizer.id}`
    const response = await ajaxDelete(url)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      setAlert({ text: 'Organizer has been deleted', type: 'success' })
      props.onDeleteOrganizer(organizer)
    }
  }

  const onTermCreated = (data) => {
    props.onCreateTerm(data)
    setTermForm()
    setAlert({ text: 'Terms and conditions have been added', type: 'success' })
  }

  const onTermUpdated = (data) => {
    props.onUpdateTerm(data)
    setTermForm()
    setAlert({ text: 'Terms and conditions have been updated', type: 'success' })
  }

  const onDeleteTermClicked = async (term) => {
    if (window.confirm('Are you sure you want to delete these terms and conditions?')) {
      deleteTerm(term)
    }
  }

  const deleteTerm = async (term) => {
    setLoading(true)
    const url = `/admins/partners/${data.id}/terms/${term.id}`
    const response = await ajaxDelete(url)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      setAlert({ text: 'Terms and conditions have been deleted', type: 'success' })
      props.onDeleteTerm(term)
    }
  }

  const updatePartner = async (params) => {
    setLoading(true)
    const url = `/admins/partners/${data.id}`
    const response = await ajaxPatch(url, params)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      setAlert({ text: 'Partner has been updated', type: 'success' })
      props.onUpdate(json.partner)
    }
  }

  return <div className={'partner-content' + (loading ? ' isLoading' : '')}>
    { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
    { loading && <div className='animated-spinner'></div> }
    <div className='header'>
      <span className='back'><a className='btn btn-success' href='/admins/partners'>Back</a></span>
      <div className='title text-center'>{data.name}</div>
    </div>
    <div className='settings'>
      <CheckInput
        label='Allow guests'
        checked={data.allow_guests}
        onChange={e => updatePartner({allow_guests: e.target.checked})}
      />
    </div>
    <div className='entities organizers'>
      <div className='entities-header'>
        <div className='entities-title'>Organizers</div>
        <button className='btn btn-success add-entity' onClick={() => setOrganizerForm({})}>Create New</button>
      </div>
      <OrganizersTable
        organizers={organizers}
        onEdit={organizer => setOrganizerForm(organizer)}
        onDelete={onDeleteOrganizerClicked}
      />
      { organizerForm && 
        <OrganizerForm
          partnerId={data.id}
          data={organizerForm}
          onClose={() => setOrganizerForm()}
          onCreate={onOrganizerCreated}
          onUpdate={onOrganizerUpdated}
        />
      }
    </div>
    <div className='entities terms'>
      <div className='entities-header'>
        <div className='entities-title'>Terms and conditions</div>
        <button className='btn btn-success add-entity' onClick={() => setTermForm({})}>Create New</button>
      </div>
      <TermsTable
        terms={terms}
        onEdit={term => setTermForm(term)}
        onDelete={onDeleteTermClicked}
      />
      { termForm && 
        <TermForm
          partnerId={data.id}
          data={termForm}
          onClose={() => setTermForm()}
          onCreate={onTermCreated}
          onUpdate={onTermUpdated}
        />
      }
    </div>
  </div>
}

Partner.propTypes = {
  data: PropTypes.object.isRequired,
  organizers: PropTypes.array.isRequired,
  terms: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCreateOrganizer: PropTypes.func.isRequired,
  onUpdateOrganizer: PropTypes.func.isRequired,
  onDeleteOrganizer: PropTypes.func.isRequired,
  onCreateTerm: PropTypes.func.isRequired,
  onUpdateTerm: PropTypes.func.isRequired,
  onDeleteTerm: PropTypes.func.isRequired,
}

export default Partner
